import { endpoints, request } from '../../core';

export const menuServices = {
  menu: () => request.get(endpoints.framework('Menu')),
  favoritesMenu: () => request.get(endpoints.framework('menu?favorites=Y')),
};
